import { AxiosResponse } from 'axios';
import { ResetPasswordRequestType, ResetPasswordResponseType } from './types';
import * as api from '../api';

export const resetPassword = (
  payload: ResetPasswordRequestType,
): Promise<AxiosResponse<ResetPasswordResponseType>> =>
  api.patch('/auth/password/reset', payload);
